import { render, staticRenderFns } from "./updateStd.vue?vue&type=template&id=27d7513a&scoped=true&"
import script from "./updateStd.vue?vue&type=script&lang=js&"
export * from "./updateStd.vue?vue&type=script&lang=js&"
import style0 from "./updateStd.vue?vue&type=style&index=0&id=27d7513a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7513a",
  null
  
)

export default component.exports